import { MappedMembershipDetails } from '@/features/membership/shared/types/mapped-membership-details';

// Past-due members get the member dashboard too — it is where they fix the payment.
// Trial members (WTDEV-1661) manage their membership like active ones.
export function showsMemberDashboard(
  membershipDetails: MappedMembershipDetails | undefined,
): membershipDetails is MappedMembershipDetails {
  switch (membershipDetails?.status) {
    case 'active':
    case 'in_trial':
    case 'past_due':
    case 'cancellation_pending':
      return true;
    default:
      return false;
  }
}
